"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var registrationValidation = (0, _validation.createValidator)({
  address: (0, _validation.requiredIf)("profile", "USER"),
  postal_code: (0, _validation.requiredIf)("profile", "USER"),
  postal_area: (0, _validation.requiredIf)("profile", "USER"),
  profile: _validation.required,
  business_id: [(0, _validation.requiredIf)("profile", "COMPANY"), _validation.businessId],
  company_name: (0, _validation.requiredIf)("profile", "COMPANY")
});
exports.default = (0, _lruMemoize2.default)(10)(registrationValidation);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/License/licenseValidator.js
 ** module id = 1218
 ** module chunks = 0
 **/